export const dict = {
    card_number: {
        required : 'Veuillez entrer votre numéro de carte',
        min : 'Veuillez rentrer un minimum de 11 caractères',
        max : 'Veuillez rentrer un maximum de 13 caractères',
    },
    email: {
        required : 'Veuillez entrer votre adresse email',
        email: 'Veuillez entrer une adresse email valide.'
    },
    mobile: {
        required : 'Veuillez entrer votre numéro de mobile',
    },
    prenom: {
        required : 'Veuillez entrer votre prénom',
    },
    nom: {
        required : 'Veuillez entrer votre nom',
    },
    zipcode: {
        required : 'Veuillez entrer votre code postal',
        numeric : 'Veuillez entrer uniquement des chiffres',
    },
    city: {
        required : 'Veuillez entrer votre ville',
    },
    address: {
        required : 'Veuillez entrer votre adresse',
    },
    magasin: {
        required : 'Veuillez choisir votre magasin',
    },
    preferred_magasin: {
        required : 'Veuillez choisir votre magasin',
    },
    rules: {
        required : 'Veuillez accepter le règlement',
    },
    condition_achat: {
        required : 'Veuillez accepter les conditions d\'achat',
    },
    data: {
        required : 'Veuillez accepter cette condition',
    },
    cg: {
        required : 'Veuillez accepter les conditions générales',
    },
    taille_tshirt: {
        is_not : 'Veuillez choisir une taille de t-shirt',
    },
    ca_min: {
        required : 'Veuillez rentrer un chiffre d\'affaires minimum',
    },
    ca_max: {
        required : 'Veuillez rentrer un chiffre d\'affaires maximum',
    },
    achat_pieces_internet: {
        required : 'Veuillez préciser le revendeur internet',
    },
    achat_pieces_magasin: {
        required : 'Veuillez préciser le magasin revendeur',
    },
    achat_pieces_autre: {
        required : 'Veuillez préciser le revendeur',
    },
    date_start_ca: {
        required_if : 'Veuillez rentrer une date de début',
    },
    date_end_ca: {
        required_if : 'Veuillez rentrer une date de fin',
    },
    date_start_achat: {
        required_if : 'Veuillez rentrer une date de début',
    },
    date_end_achat: {
        required_if : 'Veuillez rentrer une date de fin',
    },
    date_start_cde_cc: {
        required_if : 'Veuillez rentrer une date de début',
    },
    date_end_cde_cc: {
        required_if : 'Veuillez rentrer une date de fin',
    },
}
